<template>
  <div id="app" class="background color--primaryLight flex flex--column flex--space__hor">
    <div class="pad--1 flex flex--space__hor flex--center__vert">
      <router-link to="/" class="circle flex flex--center shadow--light">
        <img src="./assets/img/Logo.png" alt="Download Icon for Android" class="height--3"/>
      </router-link>
      <div class="flex headerNav">
        <router-link to="/privacy" class="noDec font--s16 font--w700 clickable mar--right__2 color--primaryDark">
          Datenschutz
        </router-link>
        <router-link to="/terms" class="noDec font--s16 font--w700 clickable mar--right__2 color--primaryDark">
          Nutzungsbedingungen
        </router-link>
        <router-link to="/imprint" class="noDec font--s16 font--w700 clickable mar--right__2 color--primaryDark">
          Impressum
        </router-link>
      </div>
    </div>
    <router-view />
    <div class="pad--1 flex flex--center font--s14 font--w500 color--primaryDark">
      © 2022 DogUniversity. All rights reserved
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
  @import "src/style/main";

  #app {
    min-height: 100vh;
  }

  .headerNav {
    @include respond(phone) {
      flex-direction: column;
      text-align: right;
    }
  }
</style>
